var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.progress
    ? _c("div", { staticClass: "admin-file-upload-progress progress" }, [
        _c(
          "div",
          {
            staticClass: "admin-file-upload-progress__bar progress-bar",
            style: { width: _vm.getProgress },
            attrs: { role: "progressbar" },
          },
          [
            _vm.progress < 100 && _vm.showProgressText
              ? _c("span", [
                  _vm._v(
                    "\n            " + _vm._s(_vm.getProgress) + "\n        "
                  ),
                ])
              : _vm._e(),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }